import { getDeviceId } from "@amplitude/analytics-browser";
import { Variant } from "@amplitude/experiment-js-client";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAccountNumber } from "@urp/store-selectors";
import tvgConf from "@tvg/conf";
import { ENV_KEYS } from "./constants";
import { VariantEnum } from "./types";
import useExperiments from "./useExperiments";

// ios2 (React Native iOS) is intentionally excluded until the RN Amplitude SDK phase is implemented.
const MEP_PRODUCTS = ["touch3", "androidwrapper", "tvgandroid"];

export const getDeploymentKey = (): string => {
  const { product } = tvgConf();
  if (MEP_PRODUCTS.includes(product)) {
    const mepKey = ENV_KEYS.tvg_mep.web;
    // Fall back to the TVG FE key while MEP deployment keys are pending Amplitude admin provisioning.
    return mepKey.startsWith("client-REPLACE_WITH_")
      ? ENV_KEYS.tvg.web
      : mepKey;
  }
  return ENV_KEYS.tvg.web;
};

export const DEPLOYMENT_KEY = getDeploymentKey();

export const useIsTreatmentVariant = (experimentKey: string) => {
  const { getVariant } = useExperiments(DEPLOYMENT_KEY);
  const variant = getVariant<VariantEnum, boolean>(experimentKey);

  return variant?.value === VariantEnum.TREATMENT;
};

export const useIsTreatmentVariantByUser = (experimentKey: string) => {
  const { setUserExperiment, getVariant } = useExperiments(DEPLOYMENT_KEY);
  const [variant, setVariant] = useState<Variant>();

  const accountNumber = useSelector(getAccountNumber);
  const deviceId = getDeviceId();

  useEffect(() => {
    if (!accountNumber) return;
    setUserExperiment({ user_id: accountNumber, device_id: deviceId }).then(
      () => {
        setVariant(getVariant<VariantEnum, number>(experimentKey));
      }
    );
  }, [accountNumber, deviceId]);

  return variant?.value === VariantEnum.TREATMENT;
};
